// Generated by i18nline and preact-i18nline.
import I18n from 'preact-i18nline/i18n';

I18n.supportedLocales = ['af','ar','az','be_BY','bg','bs','ca','cs','cy','da','de','de_AT','el','en','eo','es','et','eu','fa','fi','fr','he','hr','hu','id','it','ja','km','ko','ku','lo','lt','lv','mn','ms_MY','nl','no','pl','pt','pt_BR','ro','ru','sk_SK','sl_SI','sq','sr','sv','ta_IN','th_TH','tr','ug','uk','vi_VN','zh','zh_HK','zh_TW'];
I18n.defaultLocale = 'en';

I18n.import = locale => {
	// we use a switch here so the import statements are statically
	// analyzable. the use of import() will make build tools generate
	// separate bundles which are downloaded on-demand.
	switch (locale) {
		case 'af': return import(/* webpackChunkName: 'i18n.af' */ './af.json');
		case 'ar': return import(/* webpackChunkName: 'i18n.ar' */ './ar.json');
		case 'az': return import(/* webpackChunkName: 'i18n.az' */ './az.json');
		case 'be_BY': return import(/* webpackChunkName: 'i18n.be_BY' */ './be_BY.json');
		case 'bg': return import(/* webpackChunkName: 'i18n.bg' */ './bg.json');
		case 'bs': return import(/* webpackChunkName: 'i18n.bs' */ './bs.json');
		case 'ca': return import(/* webpackChunkName: 'i18n.ca' */ './ca.json');
		case 'cs': return import(/* webpackChunkName: 'i18n.cs' */ './cs.json');
		case 'cy': return import(/* webpackChunkName: 'i18n.cy' */ './cy.json');
		case 'da': return import(/* webpackChunkName: 'i18n.da' */ './da.json');
		case 'de': return import(/* webpackChunkName: 'i18n.de' */ './de.json');
		case 'de_AT': return import(/* webpackChunkName: 'i18n.de_AT' */ './de_AT.json');
		case 'el': return import(/* webpackChunkName: 'i18n.el' */ './el.json');
		case 'en': return import(/* webpackChunkName: 'i18n.en' */ './en.json');
		case 'eo': return import(/* webpackChunkName: 'i18n.eo' */ './eo.json');
		case 'es': return import(/* webpackChunkName: 'i18n.es' */ './es.json');
		case 'et': return import(/* webpackChunkName: 'i18n.et' */ './et.json');
		case 'eu': return import(/* webpackChunkName: 'i18n.eu' */ './eu.json');
		case 'fa': return import(/* webpackChunkName: 'i18n.fa' */ './fa.json');
		case 'fi': return import(/* webpackChunkName: 'i18n.fi' */ './fi.json');
		case 'fr': return import(/* webpackChunkName: 'i18n.fr' */ './fr.json');
		case 'he': return import(/* webpackChunkName: 'i18n.he' */ './he.json');
		case 'hr': return import(/* webpackChunkName: 'i18n.hr' */ './hr.json');
		case 'hu': return import(/* webpackChunkName: 'i18n.hu' */ './hu.json');
		case 'id': return import(/* webpackChunkName: 'i18n.id' */ './id.json');
		case 'it': return import(/* webpackChunkName: 'i18n.it' */ './it.json');
		case 'ja': return import(/* webpackChunkName: 'i18n.ja' */ './ja.json');
		case 'km': return import(/* webpackChunkName: 'i18n.km' */ './km.json');
		case 'ko': return import(/* webpackChunkName: 'i18n.ko' */ './ko.json');
		case 'ku': return import(/* webpackChunkName: 'i18n.ku' */ './ku.json');
		case 'lo': return import(/* webpackChunkName: 'i18n.lo' */ './lo.json');
		case 'lt': return import(/* webpackChunkName: 'i18n.lt' */ './lt.json');
		case 'lv': return import(/* webpackChunkName: 'i18n.lv' */ './lv.json');
		case 'mn': return import(/* webpackChunkName: 'i18n.mn' */ './mn.json');
		case 'ms_MY': return import(/* webpackChunkName: 'i18n.ms_MY' */ './ms_MY.json');
		case 'nl': return import(/* webpackChunkName: 'i18n.nl' */ './nl.json');
		case 'no': return import(/* webpackChunkName: 'i18n.no' */ './no.json');
		case 'pl': return import(/* webpackChunkName: 'i18n.pl' */ './pl.json');
		case 'pt': return import(/* webpackChunkName: 'i18n.pt' */ './pt.json');
		case 'pt_BR': return import(/* webpackChunkName: 'i18n.pt_BR' */ './pt_BR.json');
		case 'ro': return import(/* webpackChunkName: 'i18n.ro' */ './ro.json');
		case 'ru': return import(/* webpackChunkName: 'i18n.ru' */ './ru.json');
		case 'sk_SK': return import(/* webpackChunkName: 'i18n.sk_SK' */ './sk_SK.json');
		case 'sl_SI': return import(/* webpackChunkName: 'i18n.sl_SI' */ './sl_SI.json');
		case 'sq': return import(/* webpackChunkName: 'i18n.sq' */ './sq.json');
		case 'sr': return import(/* webpackChunkName: 'i18n.sr' */ './sr.json');
		case 'sv': return import(/* webpackChunkName: 'i18n.sv' */ './sv.json');
		case 'ta_IN': return import(/* webpackChunkName: 'i18n.ta_IN' */ './ta_IN.json');
		case 'th_TH': return import(/* webpackChunkName: 'i18n.th_TH' */ './th_TH.json');
		case 'tr': return import(/* webpackChunkName: 'i18n.tr' */ './tr.json');
		case 'ug': return import(/* webpackChunkName: 'i18n.ug' */ './ug.json');
		case 'uk': return import(/* webpackChunkName: 'i18n.uk' */ './uk.json');
		case 'vi_VN': return import(/* webpackChunkName: 'i18n.vi_VN' */ './vi_VN.json');
		case 'zh': return import(/* webpackChunkName: 'i18n.zh' */ './zh.json');
		case 'zh_HK': return import(/* webpackChunkName: 'i18n.zh_HK' */ './zh_HK.json');
		case 'zh_TW': return import(/* webpackChunkName: 'i18n.zh_TW' */ './zh_TW.json');
		default: return import(/* webpackChunkName: 'i18n.default' */ './default.json');
	}
};

if ((typeof module === 'object') && module.hot) {
	module.hot.accept('./af.json', I18n.reload('af'));
	module.hot.accept('./ar.json', I18n.reload('ar'));
	module.hot.accept('./az.json', I18n.reload('az'));
	module.hot.accept('./be_BY.json', I18n.reload('be_BY'));
	module.hot.accept('./bg.json', I18n.reload('bg'));
	module.hot.accept('./bs.json', I18n.reload('bs'));
	module.hot.accept('./ca.json', I18n.reload('ca'));
	module.hot.accept('./cs.json', I18n.reload('cs'));
	module.hot.accept('./cy.json', I18n.reload('cy'));
	module.hot.accept('./da.json', I18n.reload('da'));
	module.hot.accept('./de.json', I18n.reload('de'));
	module.hot.accept('./de_AT.json', I18n.reload('de_AT'));
	module.hot.accept('./el.json', I18n.reload('el'));
	module.hot.accept('./en.json', I18n.reload('en'));
	module.hot.accept('./eo.json', I18n.reload('eo'));
	module.hot.accept('./es.json', I18n.reload('es'));
	module.hot.accept('./et.json', I18n.reload('et'));
	module.hot.accept('./eu.json', I18n.reload('eu'));
	module.hot.accept('./fa.json', I18n.reload('fa'));
	module.hot.accept('./fi.json', I18n.reload('fi'));
	module.hot.accept('./fr.json', I18n.reload('fr'));
	module.hot.accept('./he.json', I18n.reload('he'));
	module.hot.accept('./hr.json', I18n.reload('hr'));
	module.hot.accept('./hu.json', I18n.reload('hu'));
	module.hot.accept('./id.json', I18n.reload('id'));
	module.hot.accept('./it.json', I18n.reload('it'));
	module.hot.accept('./ja.json', I18n.reload('ja'));
	module.hot.accept('./km.json', I18n.reload('km'));
	module.hot.accept('./ko.json', I18n.reload('ko'));
	module.hot.accept('./ku.json', I18n.reload('ku'));
	module.hot.accept('./lo.json', I18n.reload('lo'));
	module.hot.accept('./lt.json', I18n.reload('lt'));
	module.hot.accept('./lv.json', I18n.reload('lv'));
	module.hot.accept('./mn.json', I18n.reload('mn'));
	module.hot.accept('./ms_MY.json', I18n.reload('ms_MY'));
	module.hot.accept('./nl.json', I18n.reload('nl'));
	module.hot.accept('./no.json', I18n.reload('no'));
	module.hot.accept('./pl.json', I18n.reload('pl'));
	module.hot.accept('./pt.json', I18n.reload('pt'));
	module.hot.accept('./pt_BR.json', I18n.reload('pt_BR'));
	module.hot.accept('./ro.json', I18n.reload('ro'));
	module.hot.accept('./ru.json', I18n.reload('ru'));
	module.hot.accept('./sk_SK.json', I18n.reload('sk_SK'));
	module.hot.accept('./sl_SI.json', I18n.reload('sl_SI'));
	module.hot.accept('./sq.json', I18n.reload('sq'));
	module.hot.accept('./sr.json', I18n.reload('sr'));
	module.hot.accept('./sv.json', I18n.reload('sv'));
	module.hot.accept('./ta_IN.json', I18n.reload('ta_IN'));
	module.hot.accept('./th_TH.json', I18n.reload('th_TH'));
	module.hot.accept('./tr.json', I18n.reload('tr'));
	module.hot.accept('./ug.json', I18n.reload('ug'));
	module.hot.accept('./uk.json', I18n.reload('uk'));
	module.hot.accept('./vi_VN.json', I18n.reload('vi_VN'));
	module.hot.accept('./zh.json', I18n.reload('zh'));
	module.hot.accept('./zh_HK.json', I18n.reload('zh_HK'));
	module.hot.accept('./zh_TW.json', I18n.reload('zh_TW'));
	module.hot.accept('./default.json', I18n.reload('default'));
}

export default I18n;
